module.exports = __webpack_public_path__ + "static/AvenirLTProRoman-bac022e7e69073263fa8b20f2abbfb4f.woff";